import { render } from "./RequestMonitor.vue?vue&type=template&id=0b84bb2e&scoped=true"
import script from "./RequestMonitor.vue?vue&type=script&lang=js"
export * from "./RequestMonitor.vue?vue&type=script&lang=js"

import "./RequestMonitor.vue?vue&type=style&index=0&id=0b84bb2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b84bb2e"]])

export default __exports__